class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Manage hover for all details (main menu and nested submenus)
    this.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      details.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          if (details.leaveTimeout) {
            clearTimeout(details.leaveTimeout);
            details.leaveTimeout = null;
          }

          // Close all other details elements in the header navigation that do not contain this one
          document.querySelectorAll('.header__inline-menu details').forEach((otherDetails) => {
            if (otherDetails !== details && !otherDetails.contains(details)) {
              if (otherDetails.leaveTimeout) {
                clearTimeout(otherDetails.leaveTimeout);
                otherDetails.leaveTimeout = null;
              }
              otherDetails.removeAttribute('open');
              otherDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
          });

          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      details.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          details.leaveTimeout = setTimeout(() => {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }, 150);
        }
      });

      summary.addEventListener('click', (event) => {
        if (window.matchMedia('(min-width: 990px)').matches && event.detail > 0) {
          event.preventDefault();
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
